module.exports = __webpack_public_path__ + "static/img/swiper_bg.058f7aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/swiper_bg.png
// module id = fI1d
// module chunks = 0